import { render, staticRenderFns } from "./VolcanoPlot.vue?vue&type=template&id=665b5404&"
import script from "./VolcanoPlot.vue?vue&type=script&lang=js&"
export * from "./VolcanoPlot.vue?vue&type=script&lang=js&"
import style0 from "./VolcanoPlot.vue?vue&type=style&index=0&id=665b5404&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('665b5404')) {
      api.createRecord('665b5404', component.options)
    } else {
      api.reload('665b5404', component.options)
    }
    module.hot.accept("./VolcanoPlot.vue?vue&type=template&id=665b5404&", function () {
      api.rerender('665b5404', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/eglt/VolcanoPlot.vue"
export default component.exports